import { render, staticRenderFns } from "./ModuleInvoiceDetail.vue?vue&type=template&id=52b23cb8&"
import script from "./ModuleInvoiceDetail.js?vue&type=script&lang=js&"
export * from "./ModuleInvoiceDetail.js?vue&type=script&lang=js&"
import style0 from "./ModuleInvoiceDetail.vue?vue&type=style&index=0&id=52b23cb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports